<template>
  <div class="company-title">
    <h2 class="h5 text-center text-white bg-dark my-0 py-3">
      {{ $store.getters.outputOfStockSymbol }}
      {{ $store.getters.outputOfCompanyName }}
      <div v-if="isShowCompanyInfo" class="company-info">
        / 等級 {{ $store.getters.companyInfoInChartTitle.level }} / 昨收
        {{ $store.getters.companyInfoInChartTitle.closing_price }} / 淨值
        {{
          $store.getters.companyInfoInChartTitle.net_value_per_share === null
            ? "NA"
            : $store.getters.companyInfoInChartTitle.net_value_per_share
        }}
        / 近4季EPS
        {{
          $store.getters.companyInfoInChartTitle.EPS_of_recently_four_seasons
        }}
        / 每股 EBITDA
        {{ $store.getters.companyInfoInChartTitle.sum_of_EBIDTA }}
        / 季股本
        {{ $store.getters.companyInfoInChartTitle.share_capital }}
      </div>
    </h2>
  </div>
</template>

<script>
export default {
  props: {
    isShowCompanyInfo: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.company-title {
  .company-info {
    display: inline-block;
  }
}
</style>
